<section class="content">
    <div class="content-block">
        <div class="m-4"></div>
        <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <div class="card">
                    <div class="materialTableHeader">
                        <div class="left">
                            <ul class="header-buttons-left ms-0">
                                <li class="tbl-title">

                                    <!-- <img src="{{header_image}}" height="55px" width="200px"
                                    alt=""> -->
                                    
                                </li>
                                        <li class="tbl-title">
                                            <h2>Ticket System</h2>
                                        </li>
                                <li class="tbl-search-box">
                                    <label for="search-input"><i class="material-icons search-icon">search</i></label>
                                    <input placeholder="{{'COMMON.TOOL_TIP.SEARCH' |  translate}}" type="text"
                                        class="browser-default search-field" aria-label="Search box"
                                        (input)="onSearchChange($event)">
                                </li>
                            </ul>
                        </div>
                        <div class="right">
                            <ul class="tbl-export-btn">

                                <li *ngIf="isDelete === 0" class="tbl-header-btn">
                                    <div class="m-l-10" matTooltip="{{'COMMON.TOOL_TIP.ADD' | translate}}">
                                        <button aria-label="add" mat-mini-fab color="primary" (click)="addTicket()">
                                            <mat-icon class="col-white">add</mat-icon>
                                        </button>
                                    </div>
                                </li>
                                <li class="tbl-header-btn">
                                    <div class="m-l-10" matTooltip="{{'COMMON.TOOL_TIP.BACK' |
                                    translate}}">
                                        <button aria-label="close" mat-mini-fab color="warn" (click)="back()">
                                            <mat-icon class="col-white">close</mat-icon>
                                        </button>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="body overflow-auto">
                        <div class="row clearfix">
                            <div class="col" (click)="open()">
                                <div class="card profile-header" [ngClass]="{'clicked-card': isCardClicked}">
                                    <div class="body">
                                        <h6 class="card-title"><b>{{'SUPERADMIN.TICKET.CARD.OPEN' | translate}}</b>
                                        </h6>
                                        <div class="row ">
                                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-2">
                                                <div class="dashboard-count pending-invoice-bg">
                                                    <div class="icon pending-invoice-icon-bg">
                                                        <mat-icon aria-hidden="false" class="f-size"
                                                            aria-label="Example home icon f-size" fontIcon="bug_report">
                                                        </mat-icon>
                                                    </div>
                                                    <div class="details">
                                                        <div class="count">{{ticket_count.Open || 0}}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col" (click)="close()">
                                <div class="card profile-header" [ngClass]="{'clicked-card': isCloseCardClicked}">
                                    <div class="body">
                                        <h6 class="card-title"><b>{{'SUPERADMIN.TICKET.CARD.CLOSED' | translate}}</b>
                                        </h6>
                                        <div class="row ">
                                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-2">
                                                <div class="dashboard-count pending-document-bg">
                                                    <div class="icon pending-document-icon-bg">
                                                        <mat-icon aria-hidden="false" class="f-size"
                                                            aria-label="Example home icon f-size" fontIcon="build">
                                                        </mat-icon>
                                                    </div>
                                                    <div class="details">
                                                        <div class="count">{{ticket_count.Closed || 0}}</div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col" (click)="onhold()">
                                <div class="card profile-header" [ngClass]="{'clicked-card': isOnholdCardClicked}">
                                    <div class="body">
                                        <h6 class="card-title"><b>{{'SUPERADMIN.TICKET.CARD.ON_HOLD' | translate}}</b>
                                        </h6>
                                        <div class="row ">
                                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-2">
                                                <div class="dashboard-count sent-for-approval-bg">
                                                    <div class="icon sent-for-approval-icon-bg">
                                                        <mat-icon aria-hidden="false" class="f-size"
                                                            aria-label="Example home icon f-size" fontIcon="report">
                                                        </mat-icon>
                                                    </div>
                                                    <div class="details">
                                                        <div class="count">{{ticket_count.Onhold || 0}}</div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col" (click)="escalatedto3rdtier()">
                                <div class="card profile-header" [ngClass]="{'clicked-card': isEscalatedCardClicked}">
                                    <div class="body">
                                        <h6 class="card-title">
                                            <b>{{'SUPERADMIN.TICKET.CARD.ESCALATED_TO_3RD_TIER' | translate}}</b>
                                        </h6>
                                        <div class="row ">
                                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-2">
                                                <div class="dashboard-count rejected-invoice-bg">
                                                    <div class="icon rejected-invoice-icon-bg">
                                                        <mat-icon aria-hidden="false" class="f-size"
                                                            aria-label="Example home icon f-size"
                                                            fontIcon="low_priority"></mat-icon>
                                                    </div>
                                                    <div class="details">
                                                        <div class="count">{{ticket_count.Escalatedto3rdtier}}</div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col" (click)="waitingforcustomer()">
                                <div class="card profile-header" [ngClass]="{'clicked-card': isWatingCardClicked}">
                                    <div class="body">
                                        <h6 class="card-title">
                                            <b>{{'SUPERADMIN.TICKET.CARD.WAITING_FOR_CUSTOMER' | translate}}</b>
                                        </h6>
                                        <div class="row ">
                                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-2">
                                                <div class="dashboard-count on-hold-bg">
                                                    <div class="icon on-hold-icon-bg">
                                                        <mat-icon aria-hidden="false" class="f-size"
                                                            aria-label="Example home icon f-size"
                                                            fontIcon="access_time"></mat-icon>
                                                    </div>
                                                    <div class="details">
                                                        <div class="count">{{ticket_count.Waitingforcustomer || 0}}</div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="table-responsive">
                            <table mat-table #table [dataSource]="dataSource" matSort (matSortChange)="sortData($event)"
                                class="mat-cell">
                                <ng-container matColumnDef="user_name">
                                    <mat-header-cell *matHeaderCellDef mat-sort-header>
                                        {{'SUPERADMIN.TICKET.DATATABLE.CUSTOMERNAME' | translate }}
                                    </mat-header-cell>
                                    <mat-cell *matCellDef="let row" [matTooltip]="getNameTooltip(row)"
                                        (click)="editTicket(row)" (contextmenu)="onContextMenu($event, row)">
                                        <span class="truncate-text"><span class="mobile-label">
                                                Name:</span> {{row.user_name}}</span>
                                    </mat-cell>
                                </ng-container>


                                <ng-container matColumnDef="status">
                                    <mat-header-cell *matHeaderCellDef mat-sort-header>
                                        {{'SUPERADMIN.TICKET.DATATABLE.STATUS' | translate }}
                                    </mat-header-cell>
                                    <mat-cell *matCellDef="let row" [matTooltip]="getStatusTooltip(row)"
                                        (click)="editTicket(row)" (contextmenu)="onContextMenu($event, row)">

                                        <div *ngIf="row.status === 'Open'">
                                            <span>
                                                {{'SUPERADMIN.TICKET.CARD.OPEN' | translate}}</span>
                                        </div>
                                        <div *ngIf="row.status==='Closed'">
                                            <span>
                                                {{'SUPERADMIN.TICKET.CARD.CLOSED' | translate}}</span>
                                        </div>
                                        <div *ngIf="row.status==='On hold'">
                                            <span>
                                                {{'SUPERADMIN.TICKET.CARD.ON_HOLD' | translate}}</span>
                                        </div>
                                        <div *ngIf="row.status==='Escalated to 3rd tier'">
                                            <span>
                                                {{'SUPERADMIN.TICKET.CARD.ESCALATED_TO_3RD_TIER' | translate}}</span>
                                        </div>
                                        <div *ngIf="row.status==='Waiting for customer'">
                                            <span>
                                                {{'SUPERADMIN.TICKET.CARD.WAITING_FOR_CUSTOMER' | translate}}</span>
                                        </div>
                                    </mat-cell>
                                </ng-container>


                                <ng-container matColumnDef="portal_key">
                                    <mat-header-cell *matHeaderCellDef mat-sort-header>
                                        {{'SUPERADMIN.TICKET.DATATABLE.APPLICATIONNAME' | translate }}
                                    </mat-header-cell>
                                    <mat-cell *matCellDef="let row" [matTooltip]="getNameTooltip(row)"
                                        (click)="editTicket(row)" (contextmenu)="onContextMenu($event, row)">
                                        <span class="truncate-text"><span class="mobile-label">
                                                Name:</span> {{row.portal_key}}</span>
                                    </mat-cell>
                                </ng-container>

                                <ng-container matColumnDef="created_at">
                                    <mat-header-cell *matHeaderCellDef mat-sort-header class="tbl-col-width-per-max">
                                        {{'SUPERADMIN.TICKET.DATATABLE.CREATEDAT' | translate }}
                                    </mat-header-cell>
                                    <mat-cell *matCellDef="let row" (click)="editTicket(row)"
                                        class="tbl-col-width-per-max" (contextmenu)="onContextMenu($event, row)">
                                        <span class="mobile-label">Due
                                            Date:</span>{{row.created_at === 0 ? '' : (row.created_at * 1000) |
                                        date: 'MM/dd/yyyy'}}
                                    </mat-cell>
                                </ng-container>

                                <ng-container matColumnDef="updated_at">
                                    <mat-header-cell *matHeaderCellDef mat-sort-header class="tbl-col-width-per-max">
                                        {{'SUPERADMIN.TICKET.DATATABLE.UPDATEDAT' | translate }}
                                    </mat-header-cell>
                                    <mat-cell *matCellDef="let row" (click)="editTicket(row)"
                                        class="tbl-col-width-per-max" (contextmenu)="onContextMenu($event, row)">
                                        <span class="mobile-label">Due
                                            Date:</span>{{row.updated_at === 0 ? '' : (row.updated_at * 1000) |
                                        date: 'MM/dd/yyyy'}}
                                    </mat-cell>
                                </ng-container>

                                <ng-container matColumnDef="Ticket_Information">
                                    <mat-header-cell *matHeaderCellDef [ngClass]="'tbl-col-width-per-attachment'">
                                        {{ 'SUPERADMIN.TICKET.DATATABLE.INFO' | translate }}
                                    </mat-header-cell>
                                    <mat-cell class=" tbl-col-width-per-attachment" *matCellDef="let row"
                                        (contextmenu)="onContextMenu($event, row)">
                                        <div class="menu-icon"
                                            matTooltip="Email: {{ row.email }} | Phone: {{ row.phone | phoneFormatPipe}}">
                                            <i class="fas fa-info-circle cust-fontsize-tmp" id="dropdownMenuButton"
                                                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                                                aria-hidden="true"></i>
                                            <div class="dropdown-menu dropdown-content-cust"
                                                aria-labelledby="dropdownMenuButton">
                                                <span>Email: {{ row.email }}</span>
                                                |
                                                <span>Phone: {{ row.phone  | phoneFormatPipe}}</span>
                                            </div>
                                        </div>
                                    </mat-cell>
                                </ng-container>
                                <ng-container matColumnDef="priority">
                                    <mat-header-cell *matHeaderCellDef mat-sort-header
                                        [ngClass]="'tbl-col-width-per-mid'">
                                        {{'SUPERADMIN.TICKET.DATATABLE.PRIORITY' | translate }}
                                    </mat-header-cell>
                                    <mat-cell class=" tbl-col-width-per-mid" mat-cell *matCellDef="let row"
                                        (contextmenu)="onContextMenu($event, row) ">
                                        <div *ngIf="row.priority=== 'High'">
                                            <span class="badge badge-solid-red ">
                                                {{'COMMON.PRIORITY.HIGH_ALL' | translate}}</span>
                                        </div>
                                        <div *ngIf="row.priority==='Medium'">
                                            <span class="badge badge-solid-green">
                                                {{'COMMON.PRIORITY.MEDIUM_ALL' | translate}}</span>
                                        </div>
                                        <div *ngIf="row.priority==='Low'">
                                            <span class="badge badge-solid-purple">
                                                {{'COMMON.PRIORITY.LOW_ALL' | translate}}</span>
                                        </div>
                                    </mat-cell>
                                </ng-container>
                                <ng-container matColumnDef="attachment">
                                    <mat-header-cell class="psl-1" [ngClass]="'tbl-col-width-per-attachment'"
                                        *matHeaderCellDef> <i class="fas fa-paperclip"
                                            style="color:grey;padding-left: 19px !important;"></i>
                                    </mat-header-cell>
                                    <mat-cell class=" tbl-col-width-per-attachment" *matCellDef="let row"
                                        (contextmenu)="onContextMenu($event, row)">
                                        <span class="truncate-text"><span class="mobile-label"
                                                style="padding-left: 14px;">Attachment:</span>
                                            <div *ngIf="row.attachment">
                                                <div *ngIf="row.attachment.length > 0">
                                                    <i class="fas fa-paperclip" style="color:grey; padding-left: 5px;"
                                                        (click)="viewAttachment(row)"></i>
                                                </div>
                                            </div>
                                        </span>
                                    </mat-cell>
                                </ng-container>
                                <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                                <mat-row *matRowDef="let row; columns: displayedColumns;" [style.cursor]="'pointer'"
                                    matRipple>
                                </mat-row>
                            </table>
                        </div>
                        <!-- Loading spinner -->
                        <div *ngIf="ticketService?.ticketisTblLoading" class="tbl-spinner">
                            <app-loading></app-loading>
                        </div>
                        <div *ngIf="!ticketService?.ticketisTblLoading" class="no-results"
                            [style.display]="ticketList.length === 0 ? '' : 'none'">
                            {{'COMMON.LISTING.EMPTY' | translate}}
                        </div>
                        <mat-paginator #paginator [length]="pager!.total" [pageIndex]="tableRequest.pageIndex"
                            [pageSize]="tableRequest.pageSize" [pageSizeOptions]="[5, 10, 25, 100]"
                            (page)="changePage($event)">
                        </mat-paginator>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<ngx-gallery [options]="galleryOptions" [images]="galleryImages" #gallery></ngx-gallery>
